import clsx from 'clsx';
import React from 'react';
import { get, map, sortBy } from 'lodash';
import { useTranslation } from 'react-i18next';

import { ICategory } from '@/models';

import Accordion from '@/components/v2/UI/Accordion';

import useQueryParams from '@/hooks/useQueryParams';
import { useFilterHandler } from '@/hooks/products/use-filter-handler';

interface Props {
  category: ICategory;
}

const SizeFilter: React.FC<Props> = ({ category }) => {
  const { t } = useTranslation();
  const [query] = useQueryParams();
  const handler = useFilterHandler();

  const sizes = sortBy(
    sortBy(
      map(get(category.filters, 'sizes', []), size => ({
        label: size.label_size,
        value: size.label_size
      })),
      'name',
      'value'
    )
  );

  if (sizes.length === 0) {
    return null;
  }

  return (
    <Accordion
      as="ul"
      name={t(`FILTERS.size`)}
      className="grid grid-cols-3 justify-items-center gap-2 py-3"
    >
      {sizes.map(({ label, value }) => {
        const sizes = Array.isArray(query['size'])
          ? query['size']
          : [query['size']];
        const isSelected = Boolean(sizes?.includes(value));

        return (
          <li key={value} className="flex flex-col items-center w-full">
            <label
              className={clsx(
                'border px-4 py-3 w-full text-center rounded cursor-pointer',
                {
                  'border-gray-300': !isSelected,
                  'border-gray-600': isSelected
                }
              )}
            >
              <input
                type="checkbox"
                name="size"
                checked={isSelected}
                onChange={handler(value)}
                className="hidden"
              />

              <span className={clsx({ 'font-bold': isSelected })}>{label}</span>
            </label>
          </li>
        );
      })}
    </Accordion>
  );
};

export default SizeFilter;
